import { registerTools } from './webmcp-sdk-0.5.0.js';
import { askSite, context } from './webmcp-site.js';
import { searchProducts } from './webmcp-search.js';
import { getProductDetails } from './webmcp-product.js';
import { addToCart } from './webmcp-cart.js';
import { startCheckout } from './webmcp-checkout.js';

let registration;
let signature;
let unsubscribe;
let observer;
let cartCount;

function sync() {
  const data = context();
  const tools = [askSite, searchProducts];
  const product = document.querySelector('product-info[id^="MainProduct"]');
  if (data.page_type === 'product' && product && String(data.product?.id) === product.dataset.productId) {
    tools.push(getProductDetails);
    if (data.product.available && product.querySelector('form[is="product-form"]')) tools.push(addToCart);
  }
  if (data.page_type === 'cart' && cartCount > 0) tools.push(startCheckout);
  const next = `${data.product?.id || ''}:${tools.map((tool) => tool.stableKey).join(',')}`;
  if (next === signature) return;
  registration?.unregister();
  signature = next;
  registration = registerTools(tools, { telemetry: false });
  registration.ready.then((results) => {
    for (const result of results) {
      if (result.state === 'failed') console.warn('[WebMCP]', result.name, result.error);
    }
  });
}

function start() {
  if (window.Shopify?.designMode) return;
  cartCount = context().cart_count;
  sync();
  unsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, ({ cart }) => {
    if (!cart.errors) cartCount = cart.item_count;
    sync();
  });
  observer = new MutationObserver(sync);
  observer.observe(document.getElementById('MainContent'), { childList: true, subtree: true });
}

function stop() {
  registration?.unregister();
  unsubscribe?.();
  observer?.disconnect();
  signature = undefined;
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
else start();
addEventListener('pagehide', stop);
addEventListener('pageshow', (event) => { if (event.persisted) start(); });
